import { FiArrowRight, FiChevronLeft } from "react-icons/fi";
import { handlePrevious } from "../utils/navigationUtils";
import Button from "./Button";

const FormNavigationButtons = ({
  prevStep,
  nextStep = true,
  isValid,
  onClick,
  onInvalidClick,
  type = "submit",
}) => {
  return (
    <>
      <div
        className={`tw-mx-auto tw-my-6 tw-flex tw-w-full tw-max-w-[600px] tw-items-end ${
          prevStep ? "tw-justify-between" : "tw-justify-end"
        } max-[640px]:tw-gap-3`}
      >
        {/* Show Back button if there's a previous step */}
        {prevStep && (
          <Button
            type="button"
            aria-label="Previous step"
            variant="back"
            size="circle"
            onClick={() => handlePrevious(prevStep)}
            trailingIcon={
              <FiChevronLeft
                className="tw-h-[22px] tw-w-[22px]"
                strokeWidth={2.4}
                aria-hidden="true"
              />
            }
          />
        )}

        {/* Show Next button if there's a next step */}
        {nextStep && (
          <Button
            type={type}
            onClick={isValid ? onClick : onInvalidClick || null}
            aria-disabled={!isValid}
            variant={isValid ? "main" : "disabled"}
            size="card"
            className="tw-min-h-[52px] tw-gap-1 tw-pl-5 tw-pr-4 [caret-color:transparent] max-[640px]:tw-w-full max-[640px]:tw-flex-1"
            trailingIcon={
              <FiArrowRight
                className="tw-h-5 tw-w-5"
                strokeWidth={2.3}
                aria-hidden="true"
              />
            }
          >
            Next
          </Button>
        )}
      </div>
    </>
  );
};

export default FormNavigationButtons;
